import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

// Components 
import DoctorsList from './doctors/DoctorsList';
import CreateDoctor from './doctors/CreateDoctor';
import SupportTicketsList from './supportTickets/SupportTicketsList';
import CreateSupportTicket from './supportTickets/CreateSupportTicket';
import HackersList from './hackers/hackers/HackersList';
import CreateHacker from './hackers/account/CreateHacker';
import Data from './data/Data';
import PatientsList from './patients/patientsList/PatientsList';
import { useMediaQuery } from '@mui/material';
import GroupsList from './groups/GroupsList';
import Interface from '../general/containers/Interface';
import ReferralsList from './referrals/ReferralsList';
import TeamMembersList from './teamMembers/TeamMembersList';
import FaxLogsList from './fax/FaxLogsList';

const Container: React.FC = () => {

  const dispatch = useAppDispatch(); 

  const sidebarMinWidth = useMediaQuery('(max-width:600px)') ? 70 : 125;

  const colors = useAppSelector(state => state.theme.colors);
  const section = useAppSelector(state => state.navigation.section);
  const accountInfo = useAppSelector(state => state.meta.accountInfo); 

  return (

      <Interface>

          { (section === 'overview') && <Data />}

          { ((section === 'groups') && (accountInfo?.main)) && <GroupsList />}

          { ((section === 'doctors') && (accountInfo?.main)) && <DoctorsList />}

          { (section === 'createDoctor') && <CreateDoctor />}

          { (section === 'patients') && <PatientsList />}

          { (section === 'supportTickets') && <SupportTicketsList />}

          { (section === 'createSupportTicket') && <CreateSupportTicket />}

          { (section === 'referrals') && <ReferralsList />}

          { (section === 'team') && <TeamMembersList />}

          { (section === 'faxLogs') && <FaxLogsList />}

          { ((section === 'hackers') && (accountInfo?.main)) && <HackersList />}

          { ((section === 'createHacker') && (accountInfo?.main)) && <CreateHacker />}

      </Interface>
  );

};

export default Container;